import { forwardRef } from "react";
import { Col } from "components/core";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";

const ContainerFormatInput = styled(Col)`
  .MuiTextField-root {
    width: 100%;
    padding: 16px 0 0;
  }
  input {
    padding: 1em 0;
  }
`;

export const InputLine = forwardRef(
  (
    {
      type = "text",
      name = "",
      placeholder = "",
      xs = 12,
      md = 12,
      label,
      error,
      defaultValue,
      isRequired = false,
      disabled = false,
    },
    ref
  ) => {
    return (
      <ContainerFormatInput xs={xs} md={md}>
        <TextField
          name={name}
          type={type}
          inputRef={ref}
          label={label}
          defaultValue={defaultValue}
          placeholder={placeholder}
          required={isRequired}
          disabled={disabled}
          helperText={error}
        />
      </ContainerFormatInput>
    );
  }
);
